import React from 'react';
import { fromPairs, map } from 'lodash';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberOrderMarkResolved as MemberOrderMarkResolved } from 'ui/views/widgets/memberOrderMarkResolved';
 *
 * // render
 * <MemberOrderMarkResolved propName='propValue'/>
 */
export const memberOrderMarkResolved = ( props ) => {
	const fieldsData = props.widgetConfig.fields;

	return (
		<div className='ui-member-order-mark-resolved'>
			<div className='ui-member-order-mark-resolved__header'>
				{ /* title for the modal */ }
				<div className='ui-member-order-mark-resolved__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-member-order-mark-resolved__body'>
				{ /* title for the modal */ }
				<div className='ui-member-order-mark-resolved__body__title'>
					{ getLabel( props.confirmation ) }
				</div>

				<Form
					fields={ fromPairs( map( fieldsData, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
					values={ {} } // default values
					isValid={ false }
					mode={ props.mode }
					onSubmit={ ( { values, isValid } ) => {
						isValid ? props.onSumbitClick( values.description ) : null;
					} }
				>
					{ ( { fields, values, /* isValid */ errors, onChange, onSumbit } = {} ) => {
						return (
							<form
								onSubmit={ onSumbit }
								className='ui-member-order-mark-resolved__body__form'
							>
								{ /* fields */ }
								{ map( fields, ( field ) => {
									return (
										<field.view
											key={ field.name }
											className='ui-member-order-mark-resolved__body__form__field'
											name={ field.name }
											required={ field.required }
											placeholder={ field.placeholder }
											label={ field.title }
											onChange={ onChange }
											value={ values[ field.name ] }
											error={ errors[ field.name ] }
											mode={ props.mode }
											maxLength={ field.maxLength }
										/>
									);
								} ) }

                                <div className='ui-member-order-mark-resolved__body__form__actions' >
                                    { map( props.widgetConfig.actions, ( action ) => {
                                        return (
                                            <Button
                                                id={ action.name }
                                                key={ action.name }
                                                size='large'
                                                outline={ 'cancel' === action.name ? true : false }
                                                type={ 'cancel' === action.name ? 'button' : 'submit' }
                                                title={ action.title }
                                                className='ui-member-order-mark-resolved__body__form__actions__action'
                                                onClick={
                                                    'cancel' === action.name
                                                        ? () => props.closeOverlay()
                                                        : null
                                                }
                                            />
                                        );
                                    } ) }
                                </div>
							</form>
						);
					} }
				</Form>
			</div>
		</div>
	);
 };

// set display name
memberOrderMarkResolved.displayName = 'memberOrderMarkResolved';

// set default props
memberOrderMarkResolved.defaultProps = {};

// prop types
memberOrderMarkResolved.propTypes = {};
